import { Button } from "@/components/ui/button";
import { Plus, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  title: string;
  description?: string;
  buttonText?: string;
  onAction?: () => void;
  canEdit?: boolean;
  icon?: LucideIcon;
  className?: string;
}

export function EmptyState({
  title,
  description,
  buttonText,
  onAction,
  canEdit = true,
  icon: Icon = Plus,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "text-center py-12 bg-muted/50 rounded-lg border-2 border-dashed border-border",
        className
      )}
    >
      <p className="text-muted-foreground mb-4">{title}</p>
      {description && (
        <p className="text-muted-foreground text-sm mb-4">{description}</p>
      )}
      {canEdit && buttonText && onAction && (
        <Button variant="default" onClick={onAction}>
          <Icon className="h-4 w-4 mr-1" />
          {buttonText}
        </Button>
      )}
    </div>
  );
}
